export function isStringArray(arr: unknown[]): arr is string[] {
  return arr && arr.length > 0 && !!arr[0] && typeof arr[0] === 'string';
}

// Unlike isStringArray, accepts unknown input and requires every entry to be a string.
export function isStrictStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((v) => typeof v === 'string');
}

export function isRecordTypeArray(
  arr: unknown[],
): arr is Record<string, unknown>[] {
  return (
    arr &&
    arr.length > 0 &&
    !!arr[0] &&
    typeof arr[0] === 'object' &&
    !Array.isArray(arr[0])
  );
}
